import React from 'react'
import { Modal } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import useSetActivate from './hooks/useSetActivate'
interface IModalProps {
    show: boolean
    onHide: () => void
    user: IMoneyPoolResults | undefined
    refetch: () => void
}
export default function DetactivateModal({
    show,
    onHide,
    user,
    refetch,
}: IModalProps) {
    const { id } = useParams()
    const { mutate } = useSetActivate(refetch)
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-sm px-4">
                <p className=" mb-3">
                    آیا مایل به فعال سازی {user?.member.first_name}{' '}
                    {user?.member.last_name} هستید؟
                </p>
                <hr className=" my-2" />
                <p
                    className=" text-green-1"
                    onClick={() => {
                        const payload: {
                            id: string | undefined
                            poolShip: number | undefined
                        } = {
                            id,
                            poolShip: user?.id,
                        }
                        mutate(payload)
                        onHide()
                    }}
                >
                    تایید
                </p>
                <hr className=" my-2" />
                <p>بستن</p>
            </div>
        </Modal>
    )
}
